import * as yup from "yup";

import { PAYMENT_MODEL } from "@constants/panel/common";

export const brandSetupSchema = yup.object({
    payment_model       : yup.string().required("Choose how you want to pay publishers"),
    kyc_window          : yup.string().required("Choose a KYC window"),
    // Only a managed-payout brand gets a debit note raised against it, so a
    // self-payout one is never asked for a frequency (see use-brand-setup).
    debit_note_frequency: yup.string().when("payment_model", {
        is       : PAYMENT_MODEL.MANAGED_PAYOUT,
        then     : (s) => s.required("Choose a debit note frequency"),
        otherwise: (s) => s.notRequired()
    })
});

export const brandSetupDefaults = {
    payment_model       : "",
    kyc_window          : "",
    debit_note_frequency: ""
};
